
/* eslint-disable no-magic-numbers */

export const userAgent = window.navigator.userAgent;

/* browser */
const [browserName, browserVersion] = (() => {
  let tem;
  let M = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
    return ['IE', (tem[1] || '')];
  }
  if (M[1] === 'Chrome') {
    tem = userAgent.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {
      return ['Opera', tem[1]];
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = userAgent.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return [M[0], M[1]];
})();

export const browser = {
  name: browserName,
  version: browserVersion | 0,
}
export const isIE = browserName === 'IE' || browserName === 'MSIE';
export const isChrome = browserName === 'Chrome';
export const isSafari = browserName === 'Safari';
export const isFirefox = browserName === 'Firefox';
export const isSogou = /Sogou/.test(userAgent);
export const isUC = /UCBrowser/.test(userAgent);
export const ucVersion = (isUC && userAgent.split('UCBrowser/').pop().split('.').shift()) | 0;
export const isOppo = /OppoBrowser/.test(userAgent);
export const oppoVersion = (isOppo && userAgent.split('OppoBrowser/').pop().split('.').join('')) | 0;
export const isHeyTapBrowser = /HeyTapBrowser/.test(userAgent);

/* platform */
export const isTablet = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent.toLowerCase());
export const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
export const isMac = /Macintosh/.test(userAgent);

export const isAndroid = /(android)/i.test(userAgent);
export const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
export const iosVersion = isIOS && (() => {
  const VERSION_LENGTH_IN_USER_AGENT = 3;
  const VERSION_PREFIX = 'OS ';
  const start = userAgent.indexOf(VERSION_PREFIX);
  if (start > -1) {
    return userAgent.substr(start + VERSION_PREFIX.length, VERSION_LENGTH_IN_USER_AGENT).replace('_', '.') | 0;
  }
  return 0;
})();

export function isSearchBot() {
  return (/(Googlebot)|(Baiduspider)/).test(userAgent);
}

export function isFileTransferBlockedByBrowser() {
  return isOppo && oppoVersion && oppoVersion < 202
}

export function isBrowserSuppotSymbol() {
  return !(isSafari && browser.version < 9)
}

export const isIFrame = () => !(window.top === window);

export const historyLength = () => (window.history ? window.history.length : 0)
